import React from "react";
import { Tag } from "antd";
import { ChannelMode } from "../../../flatbuffers/generated/archive/channel-mode";

const MODE_CONFIG: Record<ChannelMode, { label: string; color: string }> = {
  [ChannelMode.SINGLE]: { label: "SINGLE", color: "default" },
  [ChannelMode.FAILOVER]: { label: "FAILOVER", color: "blue" },
  [ChannelMode.MERGE]: { label: "MERGE", color: "purple" },
  [ChannelMode.MIXED]: { label: "MIXED", color: "orange" },
  [ChannelMode.LOAD_BALANCE]: { label: "LB", color: "green" },
  // Multiplexes adapters over one transport, where the four above multiplex
  // endpoints into one channel — a distinct colour rather than a shade of the
  // others. Arrived with a schema bump this branch made for an unrelated
  // reason; the mode's own validation is landing separately.
  [ChannelMode.CO_RESIDENT]: { label: "CO-RES", color: "magenta" },
};

interface ChannelModeBadgeProps {
  mode: ChannelMode;
  activeEndpointName?: string | null;
}

export default function ChannelModeBadge({
  mode,
  activeEndpointName = null,
}: ChannelModeBadgeProps) {
  const cfg = MODE_CONFIG[mode] ?? MODE_CONFIG[ChannelMode.SINGLE];
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
      <Tag color={cfg.color} style={{ margin: 0 }}>
        {cfg.label}
      </Tag>
      {activeEndpointName != null && mode !== ChannelMode.SINGLE && (
        <span style={{ fontSize: 11, opacity: 0.75 }}>{activeEndpointName}</span>
      )}
    </span>
  );
}
